import * as Yup from 'yup';

export const OrganizationNotesSchema = Yup.object().shape({
  note: Yup.string().max(2000, 'Must be 2000 characters or less'),
});

export const FormInitialValues = {
  note: '',
};
